'use strict';

$(function () {
    const daysTillExpiration = 30;
    const gdprCookieName = 'gdpr-categories';
    const gdprCookieNameOptIns = 'gdpr-opt-ins';
    const gdprHideBarCookieName = 'hide-gdpr-bar';
    const $gdprModal = $('#gdpr-modal');
    const $gdprBar = $('#gdpr-bar');
    const $gdprOverlay = $('#gdpr-overlay');
    const $gdprDetailsLink = $('.gdpr-details-link');
    const $gdprSettingsLink = $('.gdpr-settings-link');
    const $gdprConfirmButtons = $('.gdpr-confirm');
    const $gdprAcceptAllButton = $('.gdpr-accept');
    const $collapseButtons = $('.collapse-button');
    const checkboxes = {
        $required: $('.gdpr-required'),
        $performance: $('.gdpr-performance'),
        $functional: $('.gdpr-functional'),
        $targeting: $('.gdpr-targeting'),
    };

    let hideGdprBar = true;
    let isCookiesPage = false;

    const gdprCategories = {
        required: true,
        performance: false,
        functional: false,
        targeting: false,
    }

    let confirmedOptIns = [];

    const init = function () {
        readCookies();
        registerEvents();
        registerOptInEvents();

        if (!hideGdprBar) {
            updateCheckboxes();
            $('body').addClass('restricted');
            $gdprOverlay.show();
            $gdprBar.fadeIn(500);
        }
    }

    const registerEvents = function () {
        $(checkboxes.$required).each(function (index, object) {
            $(object).click(function (event) {
                gdprCategories.required = event.target.checked;
            });
        });

        $(checkboxes.$performance).each(function (index, object) {
            $(object).click(function (event) {
                gdprCategories.performance = event.target.checked;
            });
        });

        $(checkboxes.$functional).each(function (index, object) {
            $(object).click(function (event) {
                gdprCategories.functional = event.target.checked;
            });
        });

        $(checkboxes.$targeting).each(function (index, object) {
            $(object).click(function (event) {
                gdprCategories.targeting = event.target.checked;
            });
        });

        $gdprDetailsLink.click(function () {
            $gdprModal.modal({backdrop: 'static', keyboard: false});
        });

        $gdprSettingsLink.click(function () {
            isCookiesPage = true;
            $gdprModal.modal({backdrop: 'static', keyboard: false});
        });

        $gdprModal.on('hide.bs.modal', function () {
            updateCheckboxes();
        });

        $gdprModal.on('show.bs.modal', function () {
            updateCheckboxes();
        });

        $gdprConfirmButtons.each(function (index, button) {
            $(button).click(function (event) {
                event.preventDefault();
                writeCookies();
                location.reload();
            });
        });

        $gdprAcceptAllButton.click(function (event) {
            event.preventDefault();
            writeCookies(true);
            location.reload();
        });

        $collapseButtons.on('click', function (event) {
            let $icon = $(event.target).parent().find('i');

            if ($icon.hasClass('kia-add')) {
                $icon.removeClass('kia-add');
                $icon.addClass('kia-less');
            } else if ($icon.hasClass('kia-less')) {
                $icon.removeClass('kia-less');
                $icon.addClass('kia-add');
            }
        });
    };

    const registerOptInEvents = function () {
        $('.gdpr-opt-in-confirm').each(function () {
            $(this).click(function () {
                if (!$(this).data('gdpr-opt-in-name')) {
                    return;
                }

                addConfirmedOptIn($(this).data('gdpr-opt-in-name'));
                window.gdprLoad();
            })
        });
    }

    const writeCookies = function (acceptAll = false) {
        Cookies.set(gdprHideBarCookieName, true, {expires: daysTillExpiration});

        let categories = [];
        for (let category in gdprCategories) {
            if (gdprCategories[category] === false && acceptAll === false) {
                continue;
            }

            categories.push(category);
        }
        Cookies.set(gdprCookieName, JSON.stringify(categories), {expires: daysTillExpiration});

        Cookies.set(gdprCookieNameOptIns, JSON.stringify(confirmedOptIns), {expires: daysTillExpiration});
    };

    const readCookies = function () {
        hideGdprBar = Cookies.get(gdprHideBarCookieName);

        if (Cookies.get(gdprCookieName)) {
            let categories = JSON.parse(Cookies.get(gdprCookieName));

            for (let category in gdprCategories) {
                if (categories.includes(category)) {
                    gdprCategories[category] = true;
                    continue;
                }

                gdprCategories[category] = false;
            }
        }

        if (Cookies.get(gdprCookieNameOptIns)) {
            confirmedOptIns = JSON.parse(Cookies.get(gdprCookieNameOptIns));
        }
    };

    const updateCheckboxes = function () {
        if (isCookiesPage) {
            readCookies();
        }
        $(checkboxes.$required).each(function (index, object) {
            $(object).prop('checked', gdprCategories.required);
        });
        $(checkboxes.$performance).each(function (index, object) {
            $(object).prop('checked', gdprCategories.performance);
        });
        $(checkboxes.$functional).each(function (index, object) {
            $(object).prop('checked', gdprCategories.functional);
        });
        $(checkboxes.$targeting).each(function (index, object) {
            $(object).prop('checked', gdprCategories.targeting);
        });
    };

    const addConfirmedOptIn = function (name) {
        readCookies();

        if (!confirmedOptIns.includes(name)) {
            confirmedOptIns.push(name);
        }

        writeCookies();
    }

    init();
});

